<template>
  <div class="agreement">
    <h2>达达兔用户协议</h2>
    <p>1、一切移动客户端用户下载安装APP，并浏览APP时均被视为已经仔细阅读本条款，对本条款没有异议，并完全接受本条款所约定的所有内容。凡以任何方式登陆本APP，或直接、间接使用本APP资料者，均被视为自愿接受本网站相关声明和用户服务协议的约束。</p>
    <p>2、通过本APP转载的内容并不代表本平台及本公司之意见及观点，也不意味着本APP及本公司赞同其观点或证实其内容的真实性。</p>
    <p>3、通过本APP转载的文字、图片、音视频等资料均由本APP用户提供，其真实性、准确性和合法性由信息发布人负责。本 APP及本公司不提供任何保证，并不承担任何法律责任。请本APP用户应自行甄别信息的真实性、合理性。通过本APP发布违法、不真实性的信息或发布侵犯第三方合法权益的信息，应赔偿由此给本APP及本公司所造成的损失。</p>
    <p>4、通过本APP所转载的文字、图片、音视频等资料，如果侵犯了第三方的知识产权或其他权利，责任由作者或转载者本人承担，本APP及本公司对此不承担责任。</p>
    <p>5、本APP及本公司不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该外部链接指向的不由APP实际控制的任何网页上的内容， 本APP及本公司不承担任何责任。</p>
    <p>6、用户明确并同意其使用本APP网络服务所存在的风险将完全由其本人承担；因其使用本APP网络服务而产生的一切后果也由其本人承担，本APP及本公司对此不承担任何责任。</p>
    <p>7、除本APP注明之服务条款外，其它因不当使用本APP而导致的任何意外、疏忽、合约毁坏、诽谤、版权或其他知识产权侵犯及其所造成的任何损失，本APP及本公司概不负责，亦不承担任何法律责任。</p>
    <p>8、对于因不可抗力或因黑客攻击、通讯线路中断等导致本APP不能控制的原因造成的网络服务中断或其他缺陷，导致用户不能正常使用本APP，本APP及本公司不承担任何责任，但将尽力减少因此给用户造成的损失或影响。</p>
    <p>9、本声明未涉及的问题请参见国家有关法律法规，当本声明与国家有关法律法规冲突时，以国家法律法规为准。</p>
    <p>10、本APP及本网站相关声明的版权及其修改权、更新权和最终解释权均属本APP及本公司所有。</p>
  </div>
</template>

<script>
import {
  Swipe,
  SwipeItem,
  Indicator,
  Toast,
  Lazyload,
  InfiniteScroll,
  Header,
  Button,
  Field,
} from "mint-ui";
import Vue from "vue";
Vue.component(Header.name, Header);
Vue.component(Button.name, Button);
export default {
  name: "Login",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.agreement {
  width: 93.6%;
  margin-left: auto;
  margin-right: auto;
}
.agreement h2 {
  font-size: 17px;
  color: #2c2c2c;
  line-height: 35px;
  font-weight: 600;
}
.agreement p {
  font-size: 14px;
  font-weight: 500;
  color: #666666;
  text-align: left;
  line-height: 20px;
  margin-bottom: 10px;
  text-align: justify;
  text-justify: inter-ideograph;
}
</style>



// WEBPACK FOOTER //
// src/components/ddtuserAgreement.vue